import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { outletJson } from "../../../DynamicFormsJson/MastersJSON/outlet";
import { MyComponentWithIconProps } from "../../../components/Comman/IconButton";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { imageUrl } from "../../../config/Url";
import endpoint from "../../../config/endpoints";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class OutletView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  onClickViewPreview = (e, row) => {
    window.open(imageUrl + row, "_blank");
  };

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.outlet + "/get-by-id?outletId=" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            let dataToSet = [];

            let outletMappedToDealerList = [
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Latitude",
                value:
                  data.data !== null && data.data.latitude !== null
                    ? data.data.latitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Longitude",
                value:
                  data.data !== null && data.data.longitude !== null
                    ? data.data.longitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Beat Name",
                value:
                  data.data.beat !== null && data.data.beat.beatName !== null
                    ? data.data.beat.beatName
                    : "",
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Stock Holder Name",
                value:
                  data.data !== null && data.data.stockStakeHolderName !== null
                    ? data.data.stockStakeHolderName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Channel Name",
                value:
                  data.data !== null && data.data.channelName !== null
                    ? data.data.channelName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Sub Channel Name",
                value:
                  data.data !== null && data.data.subChannelName !== null
                    ? data.data.subChannelName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Type",
                value:
                  data.data.outLetType !== null &&
                  data.data.outLetType.name !== null
                    ? data.data.outLetType.name
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Firm Name",
                value:
                  data.data !== null && data.data.firmName !== null
                    ? data.data.firmName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Code",
                value:
                  data.data !== null && data.data.outletCode !== null
                    ? data.data.outletCode
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Owner Name",
                value:
                  data.data !== null && data.data.ownerName !== null
                    ? data.data.ownerName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Village/city",
                value:
                  data.data !== null && data.data.villageCity !== null
                    ? data.data.villageCity
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Mobile No.",
                value:
                  data.data !== null && data.data.mobileNo !== null
                    ? data.data.mobileNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Pan No.",
                value:
                  data.data !== null &&
                  data.data.panNo !== null &&
                  data.data.panNo !== ""
                    ? data.data.panNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Email Id",
                value:
                  data.data !== null &&
                  data.data.emailId !== null &&
                  data.data.emailId !== ""
                    ? data.data.emailId
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Image",
                value:
                  data.data !== null && data.data.image !== null ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      sx={{ marginRight: "45px", align: "center" }}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={(e) =>
                        this.onClickViewPreview(e, data.data.image)
                      }
                    />
                  ) : (
                    "-"
                  ),
              },
            ];

            let outletMappedToDealerListWithAdditionalRate = [
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Latitude",
                value:
                  data.data !== null && data.data.latitude !== null
                    ? data.data.latitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Longitude",
                value:
                  data.data !== null && data.data.longitude !== null
                    ? data.data.longitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Beat Name",
                value:
                  data.data.beat !== null && data.data.beat.beatName !== null
                    ? data.data.beat.beatName
                    : "",
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Stock Holder Name",
                value:
                  data.data !== null && data.data.stockStakeHolderName !== null
                    ? data.data.stockStakeHolderName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Channel Name",
                value:
                  data.data !== null && data.data.channelName !== null
                    ? data.data.channelName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Sub Channel Name",
                value:
                  data.data !== null && data.data.subChannelName !== null
                    ? data.data.subChannelName
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Type",
                value:
                  data.data.outLetType !== null &&
                  data.data.outLetType.name !== null
                    ? data.data.outLetType.name
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Firm Name",
                value:
                  data.data !== null && data.data.firmName !== null
                    ? data.data.firmName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Code",
                value:
                  data.data !== null && data.data.outletCode !== null
                    ? data.data.outletCode
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Owner Name",
                value:
                  data.data !== null && data.data.ownerName !== null
                    ? data.data.ownerName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Village/city",
                value:
                  data.data !== null && data.data.villageCity !== null
                    ? data.data.villageCity
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Mobile No.",
                value:
                  data.data !== null && data.data.mobileNo !== null
                    ? data.data.mobileNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Pan No.",
                value:
                  data.data !== null &&
                  data.data.panNo !== null &&
                  data.data.panNo !== ""
                    ? data.data.panNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Email Id",
                value:
                  data.data !== null &&
                  data.data.emailId !== null &&
                  data.data.emailId !== ""
                    ? data.data.emailId
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Image",
                value:
                  data.data !== null && data.data.image !== null ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      sx={{ marginRight: "45px", align: "center" }}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={(e) =>
                        this.onClickViewPreview(e, data.data.image)
                      }
                    />
                  ) : (
                    "-"
                  ),
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Is Additional Rate Applicable",
                value:
                  data.data !== null &&
                  data.data.additionalRateApplicable !== null
                    ? data.data.additionalRateApplicable == "0"
                      ? "No"
                      : "Yes"
                    : "-",
              },

              // {
              //   xs: 12,
              //   sm: 6,
              //   md: 6,
              //   lg: 6,
              //   label: "Is Additional Rate Applicable",
              //   value: (
              //     <Grid item xs={12} sm={12} md={12} lg={12} container>
              //       <FormControl component="fieldset">
              //         <RadioGroup
              //           value={data.data.additionalRateApplicable}
              //           row
              //           name="additionalRateApplicable"
              //         >
              //           <FormControlLabel
              //             value="0"
              //             control={<Radio disabled />}
              //             label="No"
              //           />
              //           <FormControlLabel
              //             value="1"
              //             control={<Radio disabled />}
              //             label="Yes"
              //           />
              //         </RadioGroup>
              //       </FormControl>
              //     </Grid>
              //   ),
              // },
            ];

            let outletDataList = [
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Latitude",
                value:
                  data.data !== null && data.data.latitude !== null
                    ? data.data.latitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Longitude",
                value:
                  data.data !== null && data.data.longitude !== null
                    ? data.data.longitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Beat Name",
                value:
                  data.data.beat !== null && data.data.beat.beatName !== null
                    ? data.data.beat.beatName
                    : "",
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Type",
                value:
                  data.data.outLetType !== null &&
                  data.data.outLetType.name !== null
                    ? data.data.outLetType.name
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Firm Name",
                value:
                  data.data !== null && data.data.firmName !== null
                    ? data.data.firmName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Code",
                value:
                  data.data !== null && data.data.outletCode !== null
                    ? data.data.outletCode
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Owner Name",
                value:
                  data.data !== null && data.data.ownerName !== null
                    ? data.data.ownerName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Village/city",
                value:
                  data.data !== null && data.data.villageCity !== null
                    ? data.data.villageCity
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Mobile No.",
                value:
                  data.data !== null && data.data.mobileNo !== null
                    ? data.data.mobileNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Pan No.",
                value:
                  data.data !== null &&
                  data.data.panNo !== null &&
                  data.data.panNo !== ""
                    ? data.data.panNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Email Id",
                value:
                  data.data !== null &&
                  data.data.emailId !== null &&
                  data.data.emailId !== ""
                    ? data.data.emailId
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Image",
                value:
                  data.data !== null && data.data.image !== null ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      sx={{ marginRight: "45px", align: "center" }}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={(e) =>
                        this.onClickViewPreview(e, data.data.image)
                      }
                    />
                  ) : (
                    "-"
                  ),
              },
            ];

            let outletDataListWithAdditionalRate = [
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Latitude",
                value:
                  data.data !== null && data.data.latitude !== null
                    ? data.data.latitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Longitude",
                value:
                  data.data !== null && data.data.longitude !== null
                    ? data.data.longitude
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Beat Name",
                value:
                  data.data.beat !== null && data.data.beat.beatName !== null
                    ? data.data.beat.beatName
                    : "",
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Type",
                value:
                  data.data.outLetType !== null &&
                  data.data.outLetType.name !== null
                    ? data.data.outLetType.name
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Firm Name",
                value:
                  data.data !== null && data.data.firmName !== null
                    ? data.data.firmName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Code",
                value:
                  data.data !== null && data.data.outletCode !== null
                    ? data.data.outletCode
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Owner Name",
                value:
                  data.data !== null && data.data.ownerName !== null
                    ? data.data.ownerName
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Village/city",
                value:
                  data.data !== null && data.data.villageCity !== null
                    ? data.data.villageCity
                    : "",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Mobile No.",
                value:
                  data.data !== null && data.data.mobileNo !== null
                    ? data.data.mobileNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Pan No.",
                value:
                  data.data !== null &&
                  data.data.panNo !== null &&
                  data.data.panNo !== ""
                    ? data.data.panNo
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Email Id",
                value:
                  data.data !== null &&
                  data.data.emailId !== null &&
                  data.data.emailId !== ""
                    ? data.data.emailId
                    : "-",
              },
              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Outlet Image",
                value:
                  data.data !== null && data.data.image !== null ? (
                    <MyComponentWithIconProps
                      statusImage={VisibilityIcon}
                      sx={{ marginRight: "45px", align: "center" }}
                      color="primary"
                      fontSize="medium"
                      title="View"
                      onClick={(e) =>
                        this.onClickViewPreview(e, data.data.image)
                      }
                    />
                  ) : (
                    "-"
                  ),
              },

              {
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                label: "Is Additional Rate Applicable",
                value:
                  data.data !== null &&
                  data.data.additionalRateApplicable !== null
                    ? data.data.additionalRateApplicable == "0"
                      ? "No"
                      : "Yes"
                    : "-",
              },

              // {
              //   xs: 12,
              //   sm: 6,
              //   md: 6,
              //   lg: 6,
              //   label: "Is Additional Rate Applicable",
              //   value: (
              //     <Grid item xs={12} sm={12} md={12} lg={12} container>
              //       <FormControl component="fieldset">
              //         <RadioGroup
              //           value={data.data.additionalRateApplicable}
              //           row
              //           name="additionalRateApplicable"
              //         >
              //           <FormControlLabel
              //             value="0"
              //             control={<Radio disabled />}
              //             label="No"
              //           />
              //           <FormControlLabel
              //             value="1"
              //             control={<Radio disabled />}
              //             label="Yes"
              //           />
              //         </RadioGroup>
              //       </FormControl>
              //     </Grid>
              //   ),
              // },
            ];

            localStorage.getItem("isOutletMappedToDistributor") == 1
              ? localStorage.getItem("showIsRateApplicableOutlet") == 1
                ? (dataToSet = outletMappedToDealerListWithAdditionalRate)
                : (dataToSet = outletMappedToDealerList)
              : localStorage.getItem("showIsRateApplicableOutlet") == 1
              ? (dataToSet = outletDataListWithAdditionalRate)
              : (dataToSet = outletDataList);

            this.setState({ DataToSet: dataToSet });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Outlet View"}
            fieldMeta={[]}
            apiBaseURL={outletJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(OutletView);
